import React, { ReactElement } from 'react';
import type { CheckboxProps } from '@milanote/roma';

// Components
import {
    CurrencyCellTypeOptions,
    DateTimeCellTypeOptions,
    NumberCellTypeOptions,
    PercentageCellTypeOptions,
} from './CellTypeOptions';

// Constants
import { CellTypeNames } from '../../../../../common/table/CellTypeConstants';
import { CellTypeFormatChanges, CellTypeObjectWithAuto } from '../../../../../common/table/TableTypes';

type SharedProps = {
    updateCellTypeFormat: (cellTypeFormatChanges: CellTypeFormatChanges) => void;
    locale: string;
    formSize: CheckboxProps['size'];
};

type CellTypeFormattingInnerProps = SharedProps & {
    cellTypeObject: CellTypeObjectWithAuto;
};

const CellTypeFormatContentInner = ({
    cellTypeObject,
    ...props
}: CellTypeFormattingInnerProps): ReactElement | null => {
    switch (cellTypeObject.name) {
        case CellTypeNames.NUMBER:
            return <NumberCellTypeOptions cellTypeObject={cellTypeObject} {...props} />;
        case CellTypeNames.PERCENTAGE:
            return <PercentageCellTypeOptions cellTypeObject={cellTypeObject} {...props} />;
        case CellTypeNames.CURRENCY:
            return <CurrencyCellTypeOptions cellTypeObject={cellTypeObject} {...props} />;
        case CellTypeNames.DATE_TIME:
            return <DateTimeCellTypeOptions cellTypeObject={cellTypeObject} {...props} />;
        default:
            return null;
    }
};

type CellTypeFormattingFormatContentProps = SharedProps & {
    currentCellType: CellTypeNames;
    sharedCellTypeFormatOptions?: CellTypeObjectWithAuto;
};

const CellTypeFormatContent = ({
    currentCellType,
    updateCellTypeFormat,
    sharedCellTypeFormatOptions,
    locale,
    formSize,
}: CellTypeFormattingFormatContentProps): ReactElement | null => {
    if (!sharedCellTypeFormatOptions) return null;
    if (currentCellType !== sharedCellTypeFormatOptions.name) return null;

    return (
        <div className="FormattingOptionsPopupContent">
            <CellTypeFormatContentInner
                cellTypeObject={sharedCellTypeFormatOptions}
                updateCellTypeFormat={updateCellTypeFormat}
                locale={locale}
                formSize={formSize}
            />
        </div>
    );
};

export default CellTypeFormatContent;
